'use client'

import { usePathname } from 'next/navigation'
import type { ReactNode } from 'react'
import { isInterviewEnabled } from '@/shared/config/env'

/** 인터뷰는 자체 앱 바를 사용하고 첫 질문을 브랜드 스플래시로 가리지 않는다. */
export function SiteChrome({ children }: { children: ReactNode }) {
  const path = usePathname()
  if (isInterviewEnabled() && /^\/(?:interview|i|admin\/interview)(?:\/|$)/.test(path ?? '')) return null
  return children
}
